
export default (requests, axios) => {
    return {
        getGameTypeGroupsForSport: (sportIds) => {
            return requests.get('/market/game/group/sport/'+sportIds);
        },
    };
};